import React from 'react';
import '../components-css/header.scss'

const Header = () => {
    return (
        <div className={'header-wrapper'}>
            <div className={'header-image'}>
            </div>
            <div className={'image-wrapper'}>
                <div className={'header-title'}>Wildberies Online Courses</div>
                <div className={'header-description'}>
                    Այս դասընթացը Ձեզ հնարավորություն կտա ընդամենը 1 ամսում դառնալ ամենամեծ մարկետփլեյսներից մեկի՝
                    Wildberries-ի վաճառող 500մլն բնակչության շրջանակում կամ աշխատել որպես մենեջեր Wildberries-ում
                    գործող խանութներում և ունենալ եկամուտ սկսած 200000 դրամից։
                </div>
            </div>
        </div>
    );
};

export default Header;
